<template>
  <div class="emh-ui-dropdown-range">
    <ui-dropdown :options="minOptions" :label="minLabel" :disabled="disabled" @change="selectMinOption" />
    <wb-icon class="emh-ui-dropdown-range__divider-icon" :name.attr="'bds/arrow-right/24'" />
    <ui-dropdown :options="maxOptions" :label="maxLabel" :disabled="disabled" @change="selectMaxOption" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmhRangeDropdowns',
});
</script>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { DropdownRangeOption } from './dropdown-range.model';
import UiDropdown from '../Dropdown.vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  minLabel: {
    type: String,
    default: undefined,
  },
  minOptions: {
    type: Array as PropType<DropdownRangeOption[]>,
    required: true,
  },
  maxLabel: {
    type: String,
    default: undefined,
  },
  maxOptions: {
    type: Array as PropType<DropdownRangeOption[]>,
    required: true,
  },
});

const { minOptions, maxOptions } = toRefs(props);

const emit = defineEmits(['select-min-option', 'select-max-option']);

const selectMinOption = (selectedValue: string) => {
  const selectedOption = minOptions?.value?.find(({ value }) => value === selectedValue);

  emit('select-min-option', selectedOption);
};

const selectMaxOption = (selectedValue: string) => {
  const selectedOption = maxOptions?.value?.find(({ value }) => value === selectedValue);

  emit('select-max-option', selectedOption);
};
</script>

<style lang="scss" scoped>
.emh-ui-dropdown-range {
  display: grid;
  align-items: baseline;
  grid-column-gap: var(--wb-spacing-xxs);
  grid-template-columns: 1fr auto 1fr;

  &__divider-icon {
    color: var(--wb-grey-45);
  }
}
</style>
